"use strict";
const negateExpression = require('./negateExpression');
const { CONTAINS, NOT_CONTAINS } = require('../definitions/operators');
module.exports = negateExpression(CONTAINS, NOT_CONTAINS);
//# sourceMappingURL=notContainsExpression.js.map